export const IGetColorSchemeUseCaseType = Symbol('IGetColorSchemeUseCase');
